import { SvgIcon } from '@mui/material'

const SvgShortcuts = (props) => (
  <SvgIcon viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" name="SvgShortcuts" {...props}>
    <path d="M17 29H5a2 2 0 01-2-2V15a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2z" fill="#64b082" />
    <path d="M38 29H26a2 2 0 01-2-2V15a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2z" fill="#8e6ae8" />
    <path d="M59 29H47a2 2 0 01-2-2V15a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2z" fill="#ffe600" />
    <path d="M17 51H5a2 2 0 01-2-2V37a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2z" fill="#ffb74d" />
    <path d="M38 51H26a2 2 0 01-2-2V37a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2z" fill="#2196f3" />
    <path d="M59 51H47a2 2 0 01-2-2V37a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2z" fill="#e57373" />
  </SvgIcon>
)

export default SvgShortcuts
